export const adTypeLabels: Record<string, string> = {
  "1": "Image",
  "2": "Native",
  "3": "Video",
  "4": "Template",
};

export const getAdTypeLabel = (adType: string): string => {
  return adTypeLabels[adType] || adType;
};

export const getPlacementGroupLabel = (placementGroup: string): string => {
  const labels: Record<string, string> = {
    banner: "Banner",
    full_screen: "Full Screen",
    other: "Other",
    single: "",
  };
  return labels[placementGroup] || placementGroup;
};

export const getCombinedLabel = (adType: string, placementGroup: string): string => {
  const adLabel = getAdTypeLabel(adType);

  // For native and video, return just the ad type
  if (placementGroup === "single") {
    return adLabel;
  }

  // For image and template, combine with placement group
  const placementLabel = getPlacementGroupLabel(placementGroup);
  return `${adLabel} ${placementLabel}`;
};

export const campaignTypeLabels: Record<string, string> = {
  all: "All",
  retargeting: "Retargeting",
  impact: "Impact",
  install: "Install",
  ctv_install: "CTV",
};

export const getCampaignTypeLabel = (campaignType: string): string => {
  return campaignTypeLabels[campaignType] || campaignType;
};
